import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/warehouse-circulation-event-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const warehouseCirculationEventKinds = {
  getAll: apiPathFunc(pathBase),
} as const;
